module.exports = __webpack_public_path__ + "img/Identity-Pattern5.f27e5224.jpg";